<template>
  <section
    id="event-detail-hero-section"
    class="hero-section"
  >
    <div class="container">
      <div class="first-column">
        <nuxt-link
          class="back-button"
          to="/events"
        >
          <ArrowLeft />
          back to events
        </nuxt-link>
        <div class="date-wrapper">
          <span class="date-icon-wrapper">
            <NuxtImg
              class="date-icon"
              src="/images/events-page/events-detail/date-icon.svg"
              alt="date-icon"
              loading="lazy"
            />
            {{
              event.upcoming_or_past === 'upcoming' ? 'Upcoming' : 'Past event'
            }}
          </span>
          <span class="date">
            <span class="day">{{ event.event_date }}</span>
            <span class="hour">· {{ event.event_hour }} CET</span>
          </span>
        </div>
        <h1 class="title">{{ event.title }}</h1>
        <p
          class="subtitle"
          v-html="event.description"
        />
        <div class="event-tags">
          <span
            v-if="eventTag"
            class="event-white-tag"
          >
            {{ eventTag }}
          </span>
          <span
            v-if="event.private"
            class="event-purple-tag"
          >
            <NuxtImg
              class="logo-symbol"
              src="/images/events-page/hero/logo-symbol.svg"
              alt="logo-symbol"
              loading="lazy"
            />
            Members only
          </span>
        </div>
      </div>
      <div class="second-column">
        <div class="image-wrapper">
          <NuxtImg
            class="rectangle"
            :class="rectangleAnimated"
            src="/images/events-page/events-detail/hero-rectangle.svg"
            alt="rectangle"
          />
          <img
            v-if="eventImage"
            class="hero"
            :src="eventImage"
            alt="hero"
          />
          <NuxtPicture
            v-else
            class="hero"
            src="/images/events-page/placeholder.png"
            alt="hero"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowLeft from '~/components/Common/Svg/ArrowLeftV2.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';
export default {
  components: { ArrowLeft },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cubeAnimated: '',
      rectangleAnimated: '',
      observer: null,
    };
  },
  computed: {
    eventTag() {
      return this.event.tags?.length ? this.event.tags[0].title : false;
    },
    eventImage() {
      return this.event.header_image
        ? cloudinaryImage({ imagePath: this.event.header_image, width: 700 })
        : null;
    },
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    };

    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        this.cubeAnimated = '';
        this.rectangleAnimated = '';
      } else {
        this.cubeAnimated = 'cube-animated';
        this.rectangleAnimated = 'rectangle-animated';
      }
    };

    this.observer = new IntersectionObserver(callback.bind(this), options);
    const section = document.querySelector('#event-detail-hero-section');
    this.observer.observe(section);
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
